import { Flex } from "antd";
import MyTimesheetCalendar from "./MyTimesheetCalendar";
import TeamEmployeeList from "./TeamEmployeeList";

const MyTimesheetTeamCalendar = ({
    transformTimesheetData = () => { },
    timesheetCalendar = [],
    columns = [],
    onDateChange = () => { },
    currentDate = "",
    employeeMenu = () => { },
    pagination = {},
    isLoading = false,
    total = 0,
    setPagination = () => { },
    handleSelectEmployee = () => { },
    modalDetail = () => { },
    getAllEmployee = () => { },
}) => {

    return (
        <Flex gap={16} style={{ width: "100%", overflow: "hidden" }}>
            <TeamEmployeeList
                isLoading={isLoading}
                employeeMenu={employeeMenu}
                pagination={pagination}
                setPagination={setPagination}
                total={total}
                onSelectEmployee={handleSelectEmployee}
                getAllEmployee={getAllEmployee}
            />

            <div style={{ flex: 1, overflowX: "auto" }}>
                <>
                    <MyTimesheetCalendar
                        columns={columns}
                        timesheetCalendar={timesheetCalendar}
                        transformTimesheetData={transformTimesheetData}
                        currentDate={currentDate}
                        onDateChange={onDateChange}
                        isView={true}
                    />
                    {modalDetail()}
                </>
            </div>
        </Flex>
    )
}

export default MyTimesheetTeamCalendar;